// src/components/owners/OwnerActionsMenu.jsx
import React, { useState } from 'react';
import { MoreVertical, FileText, Download, Key, MessageCircle, History, Mail, Trash2 } from 'lucide-react';

const OwnerActionsMenu = ({ owner, onEdit, onDelete, onOpenNotes, onResetPassword }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-1 text-gray-400 hover:text-white rounded-lg transition"
      >
        <MoreVertical size={18} />
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} />
          <div className="absolute right-0 mt-2 w-48 bg-gray-800 border border-gray-700 rounded-lg shadow-lg z-20">
            <div className="py-1">
              <button
                onClick={() => {
                  setIsOpen(false);
                  onOpenNotes();
                }}
                className="w-full px-4 py-2 text-left text-sm text-gray-300 hover:bg-gray-700 flex items-center gap-2"
              >
                <MessageCircle size={14} /> Add Note / History
              </button>
              
              <button
                onClick={() => {
                  setIsOpen(false);
                  onEdit();
                }}
                className="w-full px-4 py-2 text-left text-sm text-gray-300 hover:bg-gray-700 flex items-center gap-2"
              >
                <FileText size={14} /> Edit Client
              </button>
              
              <button
                onClick={() => {
                  setIsOpen(false);
                  onResetPassword();
                }}
                className="w-full px-4 py-2 text-left text-sm text-gray-300 hover:bg-gray-700 flex items-center gap-2"
              >
                <Key size={14} /> Reset Password
              </button>
              
              <hr className="my-1 border-gray-700" />
              
              <button
                onClick={() => {
                  setIsOpen(false);
                  onDelete();
                }}
                className="w-full px-4 py-2 text-left text-sm text-red-400 hover:bg-gray-700 flex items-center gap-2"
              >
                <Trash2 size={14} /> Delete / Deactivate
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OwnerActionsMenu;